import { makeStyles } from '@mui/styles';

export const projectsInDevelopmentDetailStyle = makeStyles({
  rowDetail: {
    backgroundColor: '#f3f3f3'
  }
});
